import request from '@/utils/request'

let ProductApi = {

    /*分类管理*/
    catList(data, errorback) {
        return request._post('/shop/product.category/index', data, errorback);
    },
    /*分类添加*/
    catAdd(data, errorback) {
        return request._post('/shop/product.category/add', data, errorback);
    },
    /*分类删除*/
    catDel(data, errorback) {
        return request._post('/shop/product.category/delete', data, errorback);
    },
    /*分类修改*/
    catEdit(data, errorback) {
        return request._post('/shop/product.category/edit', data, errorback);
    },

     /*标签管理*/
     labelList(data, errorback) {
        return request._post('/shop/product.label/index', data, errorback);
    },
    /*标签添加*/
    labelAdd(data, errorback) {
        return request._post('/shop/product.label/add', data, errorback);
    },
    /*标签删除*/
    labelDel(data, errorback) {
        return request._post('/shop/product.label/delete', data, errorback);
    },
    /*标签修改*/
    labelEdit(data, errorback) {
        return request._post('/shop/product.label/edit', data, errorback);
    },

    /*产品列表*/
    productList(data, errorback) {
        return request._post('/shop/product.product/index', data, errorback);
    },
    /*产品选择列表*/
    chooseLists(data, errorback) {
        return request._post('/shop/data.product/lists', data, errorback);
    },

    /*标签选择列表*/
    chooseLabelLists(data, errorback) {
        return request._post('/shop/data.product/labelLists', data, errorback);
    },
    /*规格选择列表*/
    chooseSpec(data, errorback) {
        return request._post('/shop/data.product/spec', data, errorback);
    },
    /*新增产品*/
    addProduct(data, errorback) {
        return request._post('/shop/product.product/add', data, errorback);
    },
    /*产品基础数据*/
    getBaseData(data, errorback) {
        return request._get('/shop/product.product/add', data, errorback);
    },
    /*删除产品*/
    delProduct(data, errorback) {
        return request._post('/shop/product.product/delete', data, errorback);
    },
    /*产品基础数据*/
    getEditData(data, errorback) {
        return request._get('/shop/product.product/edit', data, errorback);
    },
    /*新增产品*/
    editProduct(data, errorback) {
        return request._post('/shop/product.product/edit', data, errorback);
    },
    /*新增规格组*/
    addSpec(data, errorback) {
        return request._post('/shop/product.spec/addSpec', data, errorback);
    },
    /*新增规格值*/
    addSpecValue(data, errorback) {
        return request._post('/shop/product.spec/addSpecValue', data, errorback);
    },
    /*商品列表不带分页*/
    getList(data, errorback) {
        return request._post('/shop/data.product/lists', data, errorback);
    },
    /*商品列表不带分页*/
    getActiveProductList(data, errorback) {
        return request._post('/shop/plus.fans.product/lists', data, errorback);
    },
    /*商品评论列表*/
    getCommentList(data, errorback) {
        return request._post('/shop/product.comment/index', data, errorback);
    },
    /*获取评论详情*/
    getComment(data, errorback) {
        return request._post('/shop/product.comment/detail', data, errorback);
    },
    /*获取评论详情*/
    editComment(data, errorback) {
        return request._post('/shop/product.comment/edit', data, errorback);
    },
    /*删除评论*/
    delComment(data, errorback) {
        return request._post('/shop/product.comment/delete', data, errorback);
    },
    /*得到分类图片*/
    cateImage(data, errorback) {
        return request._post('/shop/product.category/image', data, errorback);
    },
     /*商品设置*/
  settingDetail(data, errorback) {
    return request._get('/shop/product.setting/index', data, errorback);
  },
  /*保存商品设置*/
  editSetting(data, errorback) {
    return request._post('/shop/product.setting/index', data, errorback);
  },
  /*批量上架操作*/
  batchProduct(data, errorback) {
    return request._post('/shop/product.product/batchShelvesProduct', data, errorback);
  },
  /*批量下架操作*/
  batch_UnshelveProduct(data, errorback) {
    return request._post('/shop/product.product/batchUnShelvesProduct', data, errorback);
  },


    /*品牌管理*/
    brandList(data, errorback) {
      return request._post('/shop/product.brand/index', data, errorback);
    },
    /*品牌列表*/
    brandList2(data, errorback) {
      return request._post('/shop/product.brand/list', data, errorback);
    },
    /*品牌添加*/
    brandAdd(data, errorback) {
      return request._post('/shop/product.brand/add', data, errorback);
    },
    /*品牌删除*/
    brandDel(data, errorback) {
      return request._post('/shop/product.brand/delete', data, errorback);
    },
    /*品牌修改*/
    brandEdit(data, errorback) {
      return request._post('/shop/product.brand/edit', data, errorback);
    },
    /*得到品牌图片*/
    cateImage1(data, errorback) {
        return request._post('/shop/product.brand/image', data, errorback);
    },

    // 批量修改商品库存
    batchStock(data, errorback) {
        return request._post('/shop/product.product/batchStock', data, errorback);
    },
    // 批量修改直推收益
    batchIncome(data, errorback) {
        return request._post('/shop/product.product/batchIncome', data, errorback);
    },
    // 批量删除商品
    batchDel(data, errorback) {
        return request._post('/shop/product.product/batchDel', data, errorback);
    },
    // 批量删除商品
    batchCategory(data, errorback) {
        return request._post('/shop/product.product/batchCategory', data, errorback);
    },
    // 批量删除商品
    batchBrand(data, errorback) {
        return request._post('/shop/product.product/batchBrand', data, errorback);
    },
    /*回收站管理*/
    recycleList(data, errorback) {
      return request._post('/shop/product.product/recycleIndex', data, errorback);
    },
    // 恢复商品
    recGoods(data, errorback) {
        return request._post('/shop/product.product/recycle', data, errorback);
    },
    // 添加商品属性模板
    addAttrTemplate(data, errorback) {
        return request._post('/shop/product.Attribute/add', data, errorback);
    },
    // 商品属性模板
    attrTemList(data, errorback){
        return request._get('/shop/product.Attribute/index', data, errorback);
    },
    // 删除商品属性模板
    attrDel(data, errorback){
        return request._get('/shop/product.Attribute/delete', data, errorback);
    },
    // 获取商品属性模板
    getAttrData(data, errorback){
        return request._get('/shop/product.Attribute/getAttrData', data, errorback);
    },
    // 获取商品属性值
    getAttrDataById(data, errorback){
        return request._get('/shop/product.Attribute/getAttrDataById', data, errorback);
    },
    // 获取属性模板
    getAttrEditData(data, errorback){
        return request._get('/shop/product.Attribute/getAttrEditData', data, errorback);
    },
    /* sku管理 */
    skuList(data,errorback){
        return request._get('/shop/product.sku/list',data,errorback);
    },
     /* sku折扣价格管理 */
    editSku(data,errorback){
        return request._get('/shop/product.sku/edit',data,errorback);
    }
}

export default ProductApi;



// WEBPACK FOOTER //
// ./src/api/product.js